




import Vue from 'vue';
import importantInformationSelectCreation from '@/components/important-information/important-information-select-creation.component.vue';

export default Vue.extend({
  components: {
    'important-information-select-creation': importantInformationSelectCreation,
  },
});
